import { render, staticRenderFns } from "./order_xfd_detail.vue?vue&type=template&id=020987b0&scoped=true&"
import script from "./order_xfd_detail.vue?vue&type=script&lang=js&"
export * from "./order_xfd_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_xfd_detail.vue?vue&type=style&index=0&id=020987b0&prod&lang=scss&scoped=true&"
import style1 from "./order_xfd_detail.vue?vue&type=style&index=1&id=020987b0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020987b0",
  null
  
)

export default component.exports